$mol_view_tree2_to_js_test_ex_array_slot_foo $mol_object
	foot /string|number|boolean
		1
		true
		\foot1
		^ insert /
			2
			3
			<= ins1 \ins1
			^ sub_ins /number
				<= sub_ins1 1
			<= ins2 \ins2
		<= foot2 \foot2

